import { render, staticRenderFns } from "./JiShiClass.vue?vue&type=template&id=7d4cb24e&scoped=true"
import script from "./JiShiClass.vue?vue&type=script&lang=js"
export * from "./JiShiClass.vue?vue&type=script&lang=js"
import style0 from "./JiShiClass.vue?vue&type=style&index=0&id=7d4cb24e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4cb24e",
  null
  
)

export default component.exports